import { render, staticRenderFns } from "./CoinListView.vue?vue&type=template&id=68dbb7ca&scoped=true"
import script from "./CoinListView.vue?vue&type=script&lang=js"
export * from "./CoinListView.vue?vue&type=script&lang=js"
import style0 from "./CoinListView.vue?vue&type=style&index=0&id=68dbb7ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbb7ca",
  null
  
)

export default component.exports